import { StyleSheet, View } from 'react-native';
import {
  useResponsiveHeight,
  useResponsiveWidth,
} from '@/components/Util/reactResponsiveDimensions';
import { ClickableWordSquare } from './index';

const styles = StyleSheet.create({
  choicesWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
});

export function ClickableWordSquareContainer({
  splitWords,
  onWrong,
  onCorrect,
  currentOrder,
  guessedWords,
  wrongBoxChosen,
}) {
  // count the number of characters and words to calculate a good font size
  let choiceWordsLength = splitWords.length;
  let choicesWordsTotalCharacterCount = splitWords
    .map((choice) => choice.word)
    .join('').length;

  // get the width and height of the container to calculate a good font size
  let choicesWrapperHeight = useResponsiveHeight(20);
  let choicesWrapperWidth = useResponsiveWidth(100);
  let margin = useResponsiveWidth(1);
  let gap = useResponsiveWidth(1.5);

  // calculate a good font size for the choice word buttons based on words count, character count, screen width and ratio
  let size =
    ((choicesWrapperWidth - choiceWordsLength * margin) /
      choicesWordsTotalCharacterCount) *
    2.7;

  let screenRatio = choicesWrapperHeight / choicesWrapperWidth;
  // for potrait mode increase button size
  if (screenRatio > 0.5) {
    size = size * 2;
  }
  // if super wide screen decrease button size
  else if (screenRatio < 0.2) {
    size = size * 0.8;
  }
  // button font size can not be bigger then third the wrapper height
  size = Math.min(size, choicesWrapperHeight / 3);

  const responsiveStyles = StyleSheet.create({
    choicesWrapper: {
      justifyContent: 'center',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: gap,
    },
  });

  return (
    <View style={[styles.choicesWrapper, responsiveStyles.choicesWrapper]}>
      {splitWords.map((eachIter, index) => {
        const { word: wordValue, order, key, i } = eachIter;
        const onWrongParam = index;

        return (
          <ClickableWordSquare
            key={key}
            id={i}
            isHidden={guessedWords.includes(i)}
            currentOrder={currentOrder}
            order={order}
            word={wordValue}
            onCorrect={onCorrect}
            onWrongParam={onWrongParam}
            onWrong={onWrong}
            fontSize={size}
            margin={margin}
            wrongBoxChosen={wrongBoxChosen}
          />
        );
      })}
    </View>
  );
}
